import { createApiRequest } from "@/lib/api/createApiService";
import { COMPANY_ENDPOINTS } from "./company.endpoints";

export const companyService = {
  listCompanies: async (params = {}, options = {}) => {
    return createApiRequest({
      url: COMPANY_ENDPOINTS.LIST,
      method: "GET",
      body: params,
      ...options,
    });
  },

  getCompany: async (companyId, options = {}) => {
    if (!companyId) throw new Error("companyId is required");
    return createApiRequest({
      url: COMPANY_ENDPOINTS.DETAIL(companyId),
      method: "GET",
      ...options,
    });
  },

  createCompany: async (payload, options = {}) => {
    return createApiRequest({
      url: COMPANY_ENDPOINTS.CREATE,
      method: "POST",
      body: payload,
      ...options,
    });
  },

  updateCompany: async (companyId, payload, options = {}) => {
    if (!companyId) throw new Error("companyId is required");
    return createApiRequest({
      url: COMPANY_ENDPOINTS.UPDATE(companyId),
      method: "PATCH",
      body: payload,
      ...options,
    });
  },

  listPublicCompanies: async (params = {}, options = {}) => {
    return createApiRequest({
      url: COMPANY_ENDPOINTS.LIST_PUBLIC,
      method: "GET",
      body: params,
      ...options,
    });
  },
};
